import { Injectable, signal, computed, inject } from '@angular/core';
import { BackendService } from '../../services/backend';

@Injectable({ providedIn: 'root' })
export class TrainingState {
	private readonly backend = inject(BackendService);
	private readonly _qualityForTrainingConstants = signal<string[]>([]);
	private loaded = false;

	readonly qualityForTrainingConstants = computed(() => {
		if (!this.loaded) {
			this.load();
		}
		return this._qualityForTrainingConstants();
	});

	private load() {
		this.loaded = true;
		this.backend.getQualityForTrainingConstants().subscribe(constants => {
			this._qualityForTrainingConstants.set(constants);
		});
	}
}
